import * as React from 'react'
import { useReducer } from 'react'
//import { History } from 'history'

export type AppContextState = {
    dispatch?: React.Dispatch<{ type: string, data: any }>
    instructions: "sew" | "cut" | "contact" | "patterns"
    activeTab: "home" | "blog" | "inst"
    root: string
}

var initialState: AppContextState = {
    activeTab: "inst",
    instructions: "cut",
    root: document.domain == "pages.suddenlink.net" ? "/stranges/diapersforhaiti" : ""
}

function AppContextWrapperReducer(state: AppContextState, action: { type: string, data?: any }) {

    console.log(`AppContext Event: ${action.type}`)
    console.log(action.data)
    switch (action.type) {
        case "LOCATION_STATE":
            return {...state, ...action.data}
        case "SET_TAB":
            return { ...state, activeTab: action.data } as AppContextState
        default:
            console.log(`EVENT: ${action.type} WAS UNHANDLED!!!`)
            return state;
    }
}

interface AppContextWrapperProps {
    children: any,
    // history: History
}

export const AppContext = React.createContext<AppContextState>(initialState)

export function AppContextWrapper(props: AppContextWrapperProps) {
    const [state, dispatch] = useReducer(AppContextWrapperReducer, initialState)

    React.useEffect(() => {

        var localStorageState = window.localStorage.getItem("haiti_state");

        if(localStorageState && localStorageState.length > 0){
            dispatch({type: "LOCATION_STATE", data: JSON.parse(localStorageState)})
        }

        window.onpopstate = e => {
            window.localStorage.setItem("haiti_state", JSON.stringify(e.state))
            dispatch({type: "LOCATION_STATE", data: e.state})
        }

        return () => {
            window.onpopstate = null;
        }

    }, [])
    return <AppContext.Provider value={{ ...state, dispatch: dispatch }}>
        {props.children}
    </AppContext.Provider>
}
